import React, { useEffect } from 'react';
export function TermsOfUsePage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="min-h-screen bg-slate-50 font-sans text-slate-900" data-id="element-1118">
      <main className="py-12" data-id="element-1119">
        <div className="container mx-auto px-4 md:px-6 max-w-4xl" data-id="element-1120">
          <div className="bg-white rounded-3xl shadow-sm border border-slate-200 p-8 md:p-12 lg:p-16" data-id="element-1121">
            <h1 className="text-3xl md:text-4xl font-bold text-slate-900 mb-8 pb-8 border-b border-slate-100" data-id="element-1122">
              Términos y Condiciones de Uso
            </h1>

            <div className="text-slate-600 space-y-8 text-lg" data-id="element-1123">
              <p className="text-xl font-semibold text-slate-800" data-id="element-1124">
                Términos y Condiciones de Uso Plataformas TicketMaestro
              </p>

              <section data-id="element-1125">
                <h3 className="text-xl font-bold text-slate-900 mb-4" data-id="element-1126">
                  1. ACEPTACIÓN DE LOS TÉRMINOS
                </h3>
                <p className="leading-relaxed mb-4" data-id="element-1127">
                  Al acceder, navegar, registrarse o utilizar el sitio web,
                  aplicación móvil o cualquier plataforma digital oficial de
                  TicketMaestro SAS (en adelante nombrados como la "Plataforma"
                  y "TicketMaestro" respectivamente), el usuario declara haber
                  leído, entendido y aceptado íntegramente los presentes
                  Términos y Condiciones, así como la Política de Privacidad
                  vigente.
                </p>
                <p className="leading-relaxed" data-id="element-1128">
                  Si el usuario no está de acuerdo con estos Términos, deberá
                  abstenerse de utilizar la Plataforma.
                </p>
              </section>

              <section data-id="element-1129">
                <h3 className="text-xl font-bold text-slate-900 mb-4" data-id="element-1130">
                  2. IDENTIFICACIÓN DEL TITULAR
                </h3>
                <p className="leading-relaxed" data-id="element-1131">
                  La Plataforma es operada por TicketMaestro, sociedad
                  constituida conforme a las leyes de la República del Ecuador.
                </p>
              </section>

              <section data-id="element-1132">
                <h3 className="text-xl font-bold text-slate-900 mb-4" data-id="element-1133">
                  3. USUARIOS
                </h3>
                <p className="mb-4" data-id="element-1134">Pueden utilizar la Plataforma:</p>
                <ul className="list-disc pl-5 space-y-2 mb-4" data-id="element-1135">
                  <li data-id="element-1136">Personas naturales mayores de 18 años</li>
                  <li data-id="element-1137">
                    Menores de edad bajo la responsabilidad expresa de su padre,
                    madre o representante legal, especialmente en el caso de
                    escuelas deportivas
                  </li>
                </ul>
                <p className="leading-relaxed" data-id="element-1138">
                  El usuario es responsable de la veracidad de la información
                  proporcionada durante su registro.
                </p>
              </section>

              <section data-id="element-1139">
                <h3 className="text-xl font-bold text-slate-900 mb-4" data-id="element-1140">
                  4. SERVICIOS OFRECIDOS
                </h3>
                <p className="mb-4" data-id="element-1141">La Plataforma permite, entre otros:</p>
                <ul className="list-disc pl-5 space-y-2 mb-4" data-id="element-1142">
                  <li data-id="element-1143">
                    Administración de organizaciones, aliados, socios y
                    adherentes.
                  </li>
                  <li data-id="element-1144">Administración y venta de productos y servicios.</li>
                  <li data-id="element-1145">
                    Administración de eventos, incluyendo venta de entradas.
                  </li>
                  <li data-id="element-1146">
                    Inscripción para eventos, capacitaciones, actividades u
                    otros.
                  </li>
                  <li data-id="element-1147">
                    Pago de mensualidades, matrículas y otros valores
                    relacionados con productos y servicios.
                  </li>
                  <li data-id="element-1148">
                    Acceso a contenido informativo, promocional y multimedia.
                  </li>
                  <li data-id="element-1149">
                    Administración, gestión y operación de programas de
                    fidelización.
                  </li>
                  <li data-id="element-1150">Otros productos y servicios.</li>
                </ul>
                <p className="leading-relaxed" data-id="element-1151">
                  TicketMaestro se reserva el derecho de modificar, suspender o
                  eliminar servicios sin previo aviso.
                </p>
              </section>

              <section data-id="element-1152">
                <h3 className="text-xl font-bold text-slate-900 mb-4" data-id="element-1153">
                  5. REGISTRO Y CUENTAS
                </h3>
                <p className="mb-4" data-id="element-1154">
                  Para acceder a ciertos servicios, el usuario deberá crear una
                  cuenta proporcionando información veraz y actualizada.
                </p>
                <p className="mb-4" data-id="element-1155">El usuario es responsable de:</p>
                <ul className="list-disc pl-5 space-y-2 mb-4" data-id="element-1156">
                  <li data-id="element-1157">
                    Mantener la confidencialidad de su usuario y contraseña.
                  </li>
                  <li data-id="element-1158">Todas las actividades realizadas desde su cuenta.</li>
                </ul>
                <p className="leading-relaxed" data-id="element-1159">
                  TicketMaestro no será responsable por el uso no autorizado de
                  cuentas por negligencia del usuario.
                </p>
              </section>

              <section data-id="element-1160">
                <h3 className="text-xl font-bold text-slate-900 mb-4" data-id="element-1161">
                  6. CONDICIONES DE VENTA – PRODUCTOS Y SERVICIOS
                </h3>
                <ul className="list-disc pl-5 space-y-2 mb-4" data-id="element-1162">
                  <li data-id="element-1163">
                    Los productos y servicios están sujetos a disponibilidad de
                    stock.
                  </li>
                  <li data-id="element-1164">
                    Los precios incluyen los impuestos aplicables conforme a la
                    ley ecuatoriana.
                  </li>
                  <li data-id="element-1165">
                    Las imágenes son referenciales; pueden existir variaciones
                    mínimas.
                  </li>
                  <li data-id="element-1166">
                    Cambios o devoluciones solo se aceptarán por defectos de
                    fabricación o falta de prestación de servicio, conforme a la
                    política vigente.
                  </li>
                </ul>
                <p className="leading-relaxed" data-id="element-1167">
                  TicketMaestro no se responsabiliza por retrasos atribuibles a
                  terceros (courier, fuerza mayor, etc.).
                </p>
              </section>

              <section data-id="element-1168">
                <h3 className="text-xl font-bold text-slate-900 mb-4" data-id="element-1169">
                  7. PAGOS Y TRANSACCIONES
                </h3>
                <ul className="list-disc pl-5 space-y-2 mb-4" data-id="element-1170">
                  <li data-id="element-1171">
                    Todos los pagos se procesan a través de plataformas seguras
                    de terceros.
                  </li>
                  <li data-id="element-1172">
                    TicketMaestro no almacena información bancaria sensible.
                  </li>
                  <li data-id="element-1173">
                    El usuario autoriza el débito de los valores
                    correspondientes a los productos y servicios adquiridos.
                  </li>
                </ul>
                <p className="leading-relaxed" data-id="element-1174">
                  Cualquier reclamo deberá realizarse dentro de los plazos
                  establecidos por la ley.
                </p>
              </section>

              <section data-id="element-1175">
                <h3 className="text-xl font-bold text-slate-900 mb-4" data-id="element-1176">
                  8. PROPIEDAD INTELECTUAL
                </h3>
                <p className="leading-relaxed mb-4" data-id="element-1177">
                  Todo el contenido de la Plataforma (logos, escudos, textos,
                  imágenes, videos, diseños, marcas y software) es propiedad
                  exclusiva de TicketMaestro o de terceros autorizados.
                </p>
                <p className="leading-relaxed" data-id="element-1178">
                  Queda prohibida su reproducción, distribución o uso comercial
                  sin autorización expresa y por escrito.
                </p>
              </section>

              <section data-id="element-1179">
                <h3 className="text-xl font-bold text-slate-900 mb-4" data-id="element-1180">
                  9. USO PROHIBIDO
                </h3>
                <p className="mb-4" data-id="element-1181">El usuario se compromete a no:</p>
                <ul className="list-disc pl-5 space-y-2 mb-4" data-id="element-1182">
                  <li data-id="element-1183">Utilizar la Plataforma con fines ilícitos.</li>
                  <li data-id="element-1184">Realizar fraudes o suplantación de identidad.</li>
                  <li data-id="element-1185">Introducir virus, malware o códigos dañinos.</li>
                  <li data-id="element-1186">Afectar el funcionamiento de la Plataforma.</li>
                </ul>
                <p className="leading-relaxed" data-id="element-1187">
                  El incumplimiento podrá resultar en la suspensión o
                  cancelación inmediata de la cuenta.
                </p>
              </section>

              <section data-id="element-1188">
                <h3 className="text-xl font-bold text-slate-900 mb-4" data-id="element-1189">
                  10. RESPONSABILIDAD Y LIMITACIONES
                </h3>
                <p className="mb-4" data-id="element-1190">TicketMaestro no garantiza:</p>
                <ul className="list-disc pl-5 space-y-2 mb-4" data-id="element-1191">
                  <li data-id="element-1192">Disponibilidad ininterrumpida de la Plataforma.</li>
                  <li data-id="element-1193">Ausencia total de errores técnicos.</li>
                </ul>
                <p className="leading-relaxed" data-id="element-1194">
                  El uso de la Plataforma se realiza bajo responsabilidad
                  exclusiva del usuario.
                </p>
              </section>

              <section data-id="element-1195">
                <h3 className="text-xl font-bold text-slate-900 mb-4" data-id="element-1196">
                  11. PROTECCIÓN DE DATOS PERSONALES
                </h3>
                <p className="leading-relaxed" data-id="element-1197">
                  El tratamiento de los datos personales se rige por la Política
                  de Privacidad de TicketMaestro y la normativa vigente en
                  Ecuador.
                </p>
              </section>

              <section data-id="element-1198">
                <h3 className="text-xl font-bold text-slate-900 mb-4" data-id="element-1199">
                  12. VIGENCIA Y MODIFICACIONES
                </h3>
                <p className="leading-relaxed mb-4" data-id="element-1200">
                  TicketMaestro podrá modificar estos Términos en cualquier
                  momento.
                </p>
                <p className="leading-relaxed" data-id="element-1201">
                  La vigencia de estos Términos y Condiciones de Uso es desde el
                  20 de marzo de 2026 y permanecerá vigente hasta que exista una
                  nueva versión que la reemplace.
                </p>
              </section>

              <section data-id="element-1202">
                <h3 className="text-xl font-bold text-slate-900 mb-4" data-id="element-1203">
                  13. LEGISLACIÓN Y JURISDICCIÓN
                </h3>
                <p className="leading-relaxed mb-4" data-id="element-1204">
                  Estos Términos se rigen por las leyes de la República del
                  Ecuador.
                </p>
                <p className="leading-relaxed" data-id="element-1205">
                  Cualquier controversia será sometida a los jueces competentes
                  de la ciudad de Guayaquil.
                </p>
              </section>

              <section data-id="element-1206">
                <h3 className="text-xl font-bold text-slate-900 mb-4" data-id="element-1207">
                  14. CONTACTO
                </h3>
                <p className="leading-relaxed" data-id="element-1208">
                  Para consultas o reclamos, el usuario puede comunicarse a
                  través de los canales oficiales de TicketMaestro disponibles
                  en la Plataforma.
                </p>
              </section>
            </div>
          </div>
        </div>
      </main>
    </div>;
}